<template>
    <div>
      <div v-if="moveList.length == 0">
        <p>Loading Game Review</p>
      </div>
      <div v-for="item in moveList" v-bind:key="item.index">
        <div class="movelist-row">

          <div class="movelist-number">{{ item.index+1 }} </div>

          <div @click="onClick('white',item.index)" class="movelist-text" :class="{
                  'reptree-selected-text-dark' : (item.whiteSelected) && isDark,
                  'reptree-move-text-dark'     : (!(item.whiteSelectedd)) && isDark,
                  'reptree-selected-text-light' : (item.whiteSelected) && !isDark,
                  'reptree-move-text-light'     : (!(item.whiteSelected)) && !isDark
                }">
          {{ item.whiteSan }}</div>
          <div @click="onClick('black',item.index)" class="movelist-text" :class="{
                  'reptree-selected-text-dark' : (item.blackSelected) && isDark,
                  'reptree-move-text-dark'     : (!(item.blackSelectedd)) && isDark,
                  'reptree-selected-text-light' : (item.blackSelected) && !isDark,
                  'reptree-move-text-light'     : (!(item.blackSelected)) && !isDark
                }">
          {{ item.blackSan }}</div>

          <div class="movelist-text">{{ item.whiteScore }}</div>
          <div class="movelist-text">{{ item.blackScore }}</div>
        </div>
        <hr>
      </div>
    </div>

</template>

<script setup>

  import { IonIcon,IonPage, IonContent , modalController } from '@ionic/vue';

  import { computed } from "@vue/reactivity"

  import { ref, watch, onMounted, onBeforeUnmount } from 'vue'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useGetData } from '@/composables/getData.js'

  const emit = defineEmits(['move-list-click'])

  const props = defineProps({
    gameId : {
      type : String,
      default : ""
    },
    directionClicked : String,
    directionTrigger : {
      type : Number,
      default : 0 
    }
    })

  const connectionStore = useConnectionStore()
  const isDark = ref(connectionStore.getDarkmode != "light")
 
  var blankAppendTrigger = " "
  const orientation = ref("white")
  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  var fen = INITIAL_FEN

  var moveCount = 0
  var plyCount = 0
  const moveList = ref([])

  var selectedMoveIndex = -1
  var selectedMoveColor = ""

  const directionTrigger = computed({ get() { return props.directionTrigger } })
  const gameId = computed({ get() { return props.gameId } })

  onMounted(() => {
   })

   
   watch(gameId, (newVal,oldVal) => {
    //console.log("gameId changed",newVal,oldVal)
    if (newVal != "")
      getGame(newVal)
  })

  watch(directionTrigger, (newVal,oldVal) => {
    //console.log("direction Trigger",newVal,oldVal, props.directionClicked)
    directionClick(props.directionClicked)
  })

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function onClick(color,index) {
    //console.log("on click ",color,index)
    var newFen = ""

    var fen = ""
    if (index == -1)
      fen = INITIAL_FEN
    else {
      if (color == "white")
        newFen = moveList.value[index].whiteFen 
      else
        newFen = moveList.value[index].blackFen
      if (newFen != undefined && newFen != "")
        fen = newFen
    }
    // remove any selected
    for (var i=0; i < moveList.value.length; i++) {
      moveList.value[i].whiteSelected = false
      moveList.value[i].blackSelected = false
    }

    if (index >= 0) {
      if (color == "white")
        moveList.value[index].whiteSelected = true
      else
        moveList.value[index].blackSelected = true
    }
    selectedMoveColor = color
    selectedMoveIndex = index

    const rewindDisabled = (selectedMoveColor == "" &&  selectedMoveIndex == -1)

    var atLastMove = false
    if (selectedMoveIndex == moveList.value.length - 1)
      if (moveList.value[index].blackFen == undefined || moveList.value[index].blackFen == "")
        atLastMove = true
      else
        if (selectedMoveColor == "black")
          atLastMove = true
    
    const lastDisabled = atLastMove

    
    //console.log("*** EMIT *** ", fen,rewindDisabled,lastDisabled)
    emit('move-list-click',fen,rewindDisabled,lastDisabled)
  }

  function directionClick(directionString) {
    //console.log("in direction click", directionString)
    switch (directionString) {
      case "rewind" :
        //if (toolbarElements.value[TOOLBAR_REWIND].disabled == true)
        //  break
        onClick("",-1)
        break
      case "back" :
        // if (toolbarElements.value[TOOLBAR_BACK].disabled == true)
        //   break
        if (selectedMoveColor == "black")
          onClick("white",selectedMoveIndex)
        else
          if (selectedMoveIndex == 0)
            onClick("",-1)
          else
            onClick("black",selectedMoveIndex - 1)
        break
      case "next" :
        //if (toolbarElements.value[TOOLBAR_NEXT].disabled == true)
        //  break
        if (selectedMoveIndex == -1)
          onClick("white",0)
        else
          if (selectedMoveColor == "white")
            onClick("black",selectedMoveIndex)
          else
            onClick("white",selectedMoveIndex + 1)
        break
      case "last" :
        //if (toolbarElements.value[TOOLBAR_LAST].disabled == true)
        //  break
        const lastMoveColor = (moveList.value[moveList.value.length - 1].blackFen != undefined &&
                  moveList.value[moveList.value.length - 1].blackFen != "") ? "black" : "white"
        onClick(lastMoveColor,moveList.value.length - 1)
        break
    }
  }

   const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function processJsonResponse (json) {
    //console.log(" in game review callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    selectedMoveIndex = -1
    selectedMoveColor = ""

    moveCount = Math.floor(json["move_count"])

    const whiteString = Math.floor(json["white"])
    orientation.value = (whiteString == 1) ? "white" : "black"

    const fens = json["fens"].split(",")
    const froms = json["froms"].split(",")
    const tos = json["tos"].split(",")
    const sans = json["sans"].split(",")
    const promotes = json["promotes"].split(",")
    const scores = json["scores"].split(",")

    plyCount = sans.length
    if (plyCount > 0 && sans[plyCount-1] == "")
        plyCount -= 1
        
    moveList.value = []
 
    for (var i = 0; i < moveCount; i++) {
      const plyNumber = i * 2
      const oneMove = {
        index : i,
        whiteFen : fens[plyNumber],
        blackFen : fens[plyNumber + 1],
        whiteSan : sans[plyNumber],
        blackSan : sans[plyNumber + 1],
        whiteSelected : false,
        blackSelected : false,
        whiteScore : scores[plyNumber],
        blackScore : scores[plyNumber + 1]
      }
      moveList.value.push(oneMove)
    }
    
    //console.log("Move List ",moveList.value)
    fen = INITIAL_FEN

    emit('move-list-click',fen,true,false)
  }
  
  function getGame(gameId) {
    var formData = {
      id : gameId
    }
    //console.log("get game formdata",formData)
    useGetData("chessvis_blind_game.php", formData, processJsonResponse)
  }

</script>

<style scoped>

.movelist-row {
  line-height: 1.0rem;
}

.movelist-number {
  display: inline-block;
  width : 8%;
  position : relative;
}

.movelist-text {
  display: inline-block;
  width : 20%;
  margin-right : 3%;
  position : relative;
  padding: 2px;
}

.reptree-move-text-light {
  color : rgb(13,110,253)
}
.reptree-move-text-dark {
  color : #fff;
}
.reptree-selected-text-light {
  color : blue;
  background : yellow;
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

</style>

